var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _line, _path4, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 264,
    viewBox: "0 0 314 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 306.418,
    height: 182.533,
    rx: 16,
    transform: "matrix(1 0 0 -1 7.24854 191.636)",
    fill: "#82ADF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24854 150.781L313.667 150.781V25.1034C313.667 16.2668 306.503 9.10336 297.667 9.10336L23.2485 9.10336C14.412 9.10336 7.24854 16.2668 7.24854 25.1034L7.24854 150.781Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: -2,
    width: 302.418,
    height: 178.533,
    rx: 14,
    transform: "matrix(1 0 0 -1 0 179.07)",
    stroke: "#153243",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4397,
    y: 243.035,
    width: 168.695,
    height: 20.4279,
    rx: 8,
    fill: "#82ADF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.123 187.683H135.754C133.989 187.683 132.433 188.839 131.924 190.529L115.319 245.671H205.926L189.123 187.683Z",
    fill: "#82ADF7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.947368,
    y: -0.947368,
    width: 13.7123,
    height: 4.03594,
    rx: 2.01797,
    transform: "matrix(1 0 0 -1 19.1099 25.0005)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.89474
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.947368,
    y: -0.947368,
    width: 13.7123,
    height: 4.03594,
    rx: 2.01797,
    transform: "matrix(1 0 0 -1 40.0234 25.0005)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.89474
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.947368,
    y: -0.947368,
    width: 13.7123,
    height: 4.03594,
    rx: 2.01797,
    transform: "matrix(1 0 0 -1 60.9366 25.0005)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.89474
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.16083,
    y: -0.183826,
    width: 22.1954,
    height: 6.53276,
    rx: 3.26638,
    transform: "matrix(0.7645 0.644623 0.644623 -0.7645 103.009 65.1167)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 3.06691
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0336295,
    y: -2.16837,
    width: 22.1954,
    height: 6.53276,
    rx: 3.26638,
    transform: "matrix(0.717987 -0.696056 -0.696056 -0.717987 107.955 79.2994)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 3.06691
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.16083,
    y: -0.183826,
    width: 22.1954,
    height: 6.53276,
    rx: 3.26638,
    transform: "matrix(0.7645 0.644623 0.644623 -0.7645 179.806 65.1167)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 3.06691
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0336295,
    y: -2.16837,
    width: 22.1954,
    height: 6.53276,
    rx: 3.26638,
    transform: "matrix(0.717987 -0.696056 -0.696056 -0.717987 184.752 79.2994)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 3.06691
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8446 127.717L100.667 126.155C104.944 122.488 110.966 121.651 116.081 124.012L118.737 125.238C122.031 126.759 125.901 126.3 128.749 124.052V124.052C131.76 121.675 135.893 121.309 139.274 123.121L141.518 124.323C145.453 126.43 150.201 126.336 154.048 124.073L154.545 123.78C158.351 121.542 163.085 121.605 166.829 123.945V123.945C170.543 126.266 175.233 126.349 179.027 124.161L180.091 123.547C183.732 121.446 188.232 121.505 191.817 123.7V123.7C195.787 126.13 200.83 125.922 204.586 123.174L208.736 120.138",
    stroke: "#153243",
    strokeWidth: 9.33
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 152.075,
    x2: 306.418,
    y2: 152.075,
    stroke: "#153243",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.874 181.752H128.505C126.74 181.752 125.184 182.908 124.675 184.598L108.07 239.74H198.677L181.874 181.752Z",
    stroke: "#153243",
    strokeWidth: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1912,
    y: 240.422,
    width: 164.695,
    height: 16.4279,
    rx: 6,
    stroke: "#153243",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/Computer.9931fe3e.svg";
export { ForwardRef as ReactComponent };